<template>
  <div>
    <mt-cell
      :title="option.name"
      is-link
      to="click"
      @cellClick="handleClick"
      class="oa-cell"
    >
      <i
        class="iconfont icon-center"
        slot="icon"
        :class="iconMap[option.ext] || iconMap.default"
      ></i>
    </mt-cell>
  </div>
</template>
<script>
import { Cell,Toast } from "bh-mint-ui2";
import * as utils from "../../utils";
import api from "../../api";
export default {
  name: "attachmentCell",
  props: ["option"],
  components: {
    Cell,
  },
  data() {
    return {
      iconMap: {
        pdf: "icon-pdf oa-FD3B30",
        docx: "icon-word- oa-2D8CF0",
        doc: "icon-word- oa-2D8CF0",
        jpg: "icon-pic oa-FFC600",
        png: "icon-pic oa-FFC600",
        default: "icon-other oa-00CC66",
      },
    };
  },
  methods: {
    handleClick() {
      let that = this;
      let isWeiXin = () => /micromessenger/.test(navigator.userAgent.toLowerCase());
      let isDingTalk = () => /dingtalk/.test(navigator.userAgent.toLowerCase());
      let isDaliyCampus = () => /wisedu/.test(navigator.userAgent.toLowerCase());
      var isIphone = function () {
        return /iphone/.test(navigator.userAgent.toLowerCase());
      };
      const ext = this.option.name.substring(this.option.name.lastIndexOf(".") + 1);
      var param = {
        fileWid: this.option.id,
        ext: ext,
      };
      this.$indicator.open();
      utils.Post(api.getYzDcsAttachmentUrl, param).then(data => {
        that.$indicator.close();
        if (data.code === "1" && data.data) {
          window.open(data.data)
        } else {
          // Toast({
          //   message: "附件预览URL不存在.",
          //   className: "toast-top",
          // });
          window.open(window.location.origin + this.option.fileUrl)
        }
      }).catch(()=>{
        window.open(window.location.origin + this.option.fileUrl)
      })
      // var isImage = this._isImage(ext);
      // if (!isImage) {
      //   if (isDaliyCampus() && !isIphone()) {
      //     if (this._isSpecialFile(ext)) {
      //       location.href = window.location.origin + this.option.fileUrl;
      //     } else {
      //       var url = window.location.origin + this.option.fileUrl;
      //       global.SDK.bh.file.filePreview(encodeURI(url), ext, this.option.name);
      //     }
      //   } else {
      //     location.href = this.option.fileUrl;
      //   }
      // } else {
      //   if (isWeiXin() && isIphone()) {
      //     location.href = this.option.url;
      //   } else {
      //     let imgs = [];
      //     let index = 0;
      //     imgs.push({
      //       url: location.origin + this.option.url,
      //     });
      //     global.SDK.preViewImages(imgs, index);
      //   }
      // }
    },
    _isSpecialFile(type) {
      return /pdf$|PDF$|rar$|RAR$|zip$|ZIP$/.test(type);
    },
    _isImage(file) {
      return /JPG$|JPEG$|PNG$|GIF$|BMP$|jpg$|jpeg$|png$|gif$|bmp$/.test(file);
    },
    _nonsupportPreview(type) {
      return /rar$|RAR$|zip$|ZIP$/.test(type);
    },
  },
};
</script>
<style scoped>
.oa-cell .icon-center {
    margin-right: 8px;
    font-size: 24PX;
    vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// attachmentCell.vue?243d9d19